import { resultScope } from "../definitions/element";

export enum Scopes {
  ListGlobal = "listGlobal",
  ListSection = "listSection",
  JointDetail = "jointDetail",
  ProjectsList = "projectList",
  AddProjectForm = "addProjectForm",
  SectionsList = "sectionsList",
  AddSectionForm = "addSectionForm",
}

export const configList = [
  Scopes.AddProjectForm,
  Scopes.AddSectionForm,
  Scopes.JointDetail,
  Scopes.ListGlobal,
  Scopes.ListSection,
  Scopes.ProjectsList,
  Scopes.SectionsList,
];

export const fields = [
  {
    id: "joint_name",
    name: "joint_name",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "joint_type",
    name: "joint_type",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "element_type",
    name: "element_type",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "element_type_1",
    name: "element_type_1",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "element_type_2",
    name: "element_type_2",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "diameter_1",
    name: "diameter_1",
    type: "string",
    formType: "number",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "diameter_2",
    name: "diameter_2",
    type: "string",
    formType: "number",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "thickness_1",
    name: "thickness_1",
    type: "string",
    formType: "number",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "thickness_2",
    name: "thickness_2",
    type: "string",
    formType: "number",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "material_1",
    name: "material_1",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "material_2",
    name: "material_2",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "sourceElementID",
    name: "sourceElementID",
    type: "string",
    formType: "none",
    label: "",
    scope: [],
  },
  {
    id: "welder",
    name: "welder",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
   {
    id: "spoolID",
    name: "spoolID",
    type: "string",
    formType: "fill",
    sourceType: 'field',
    sourceFiled:'spools',
    sourceScope: 'projectDetails',
    scope: [Scopes.JointDetail, Scopes.ListGlobal,Scopes.ListSection],
  },
  {
    id: "welding_date",
    name: "welding_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "melt_number_1",
    name: "melt_number_1",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "melt_number_2",
    name: "melt_number_2",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "vt_examination_number",
    name: "vt_examination_number",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "vt_examination_date",
    name: "vt_examination_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "vt_examination_result",
    name: "vt_examination_result",
    type: "source",
    formType: "select",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
    options: resultScope,
  },
  {
    id: "rt_examination_number",
    name: "rt_examination_number",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "rt_examination_date",
    name: "rt_examination_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.JointDetail],
  },
  {
    id: "rt_examination_result",
    name: "rt_examination_result",
    type: "source",
    formType: "select",
    source: 'options',
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
    options: resultScope,
  },
  {
    id: "pt_examination_number",
    name: "pt_examination_number",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "pt_examination_date",
    name: "pt_examination_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "pt_examination_result",
    name: "pt_examination_result",
    type: "source",
    formType: "select",
    source: 'options',
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
    options: resultScope,
  },
  {
    id: "ut_examination_number",
    name: "ut_examination_number",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "ut_examination_date",
    name: "ut_examination_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "ut_examination_result",
    name: "ut_examination_result",
    type: "source",
    formType: "select",
    source: 'options',
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
    options: resultScope,
  },
  {
    id: "mt_examination_number",
    name: "mt_examination_number",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "mt_examination_date",
    name: "mt_examination_date",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
  },
  {
    id: "mt_examination_result",
    name: "mt_examination_result",
    type: "source",
    formType: "select",
    source: 'options',
    scope: [Scopes.ListGlobal, Scopes.ListSection, Scopes.JointDetail],
    options: resultScope,
  },
  {
    id: "kks",
    name: "kks",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection,Scopes.SectionsList],
  },
  {
    id: "page",
    name: "page",
    type: "string",
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection],
  },
  {
    id: "sectionName",
    name: "sectionName",
    type: "source",
     sourceFiled:'sectionID',
     sourceScope:'sections',
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ListSection,Scopes.SectionsList],
  },
  {
    id: "projectName",
    name: "projectName",
    type: "source",
    sourceFiled:'projectID',
    sourceScope:'projects',
    formType: "text",
    scope: [Scopes.ListGlobal, Scopes.ProjectsList, Scopes.ListSection,Scopes.SectionsList],
  },
  {
    id: "contractName",
    name: "contractName",
    type: "source",
    sourceType: 'field',
    sourceFiled:'contractID',
    sourceScope: 'contracts',
    formType: "select",
    scope: [Scopes.ListGlobal, Scopes.ProjectsList, Scopes.ListSection],
  },
  {
    id: "author",
    name: "author",
    type: "text",
    formType: "string",
    scope: [Scopes.ProjectsList],
  },
  {
    id: "createdTime",
    name: "createdTime",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ProjectsList,Scopes.SectionsList],
  },
  {
    id: "updatedTime",
    name: "updatedTime",
    type: "number | undefined",
    formType: "date",
    scope: [Scopes.ProjectsList,Scopes.SectionsList],
  },
  {
    id: "fileName",
    name: "fileName",
    type: "string",
    formType: "text",
    scope: [Scopes.SectionsList],
  },
  {
    id: "status",
    name: "status",
    type: "string",
    formType: "text",
    scope: [Scopes.SectionsList,Scopes.AddProjectForm, Scopes.AddSectionForm],
  },
   {
    id: "revision",
    name: "revision",
    type: "string",
    formType: "number",
    scope: [Scopes.SectionsList, Scopes.AddSectionForm,Scopes.ListGlobal,Scopes.ListSection],
  },
  {
    id: "file",
    name: "file",
    type: "file",
    formType: "file",
    scope: [],
  },
];
